export default __webpack_public_path__ + "static/media/template-icon.f49d6d72.svg";